

const PackageSubscribe = () => {
    return(
        <div className="feasibility-study feasibility-study-adjustment">
            <div className="overlay">
                <div className="container d-flex justify-content-end">
                    <div className="content">
                            <p className="subtitle">الرئيسية / غير مصنف / دراسة جدوى أولية</p>
                            <h3 className="title">دراسة جدوى أولية</h3>
                            <p className="price">1,200.00<span> ر.س </span></p>
                            <p className="package-details">
                            صممت دراسة الجدوى الأولية لتعطي رائد الأعمال القدرة على تحديد مدى
                            وضوح وجدوى المشروع بدون معرفتة التفاصيل بعمق وهي طريقة فعالة
                            للمشاريع الصغيرة أو المنزلية التي تقوم على فكرة الفرد الواحد
                            غالباً.
                             </p>
                        <a className="main-btn" href="#subscribeModel" data-toggle="modal">إشترك</a>
                    </div>
                </div>
            </div>
        </div>
    );

};
export default PackageSubscribe;
